/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../utils/service";

const useDeleteSurvey = (surveyId) =>
  useMutation({
    mutationKey: ["deleteSurvey", surveyId],
    mutationFn: (surveyId) => service.deleteSurvey(surveyId),
  });

export default useDeleteSurvey;
